import { render, staticRenderFns } from "./FormFeriado.vue?vue&type=template&id=8d847d1e"
import script from "./FormFeriado.vue?vue&type=script&lang=js"
export * from "./FormFeriado.vue?vue&type=script&lang=js"
import style0 from "./FormFeriado.vue?vue&type=style&index=0&id=8d847d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports